





























import {
  Vue, Component, Prop, Watch, Mixins, Emit, PropSync,
} from 'vue-property-decorator'
import {
  both, includes, filter, sortBy, sortWith, prop, descend, ascend,
} from 'ramda'
import dayjs from 'dayjs'
import {
  getModule,
} from 'vuex-module-decorators'
import { DisplaySlideType, DisplayBoardType, SlideDetailsType } from '../../types'
import MainMixin from '../../mixins/MainMixin'
import EventBus from '../../event-bus'
import prettyHour from '../../helpers/system/prettyHour'

type SingleDayTime = {
  start:number,
  end:number
}

@Component({
  components: {
  },
})


export default class AllBoards<T extends Vue> extends Mixins(MainMixin) {
  @Prop() dayStartTime!:number

  @PropSync('allTimes') times!:SingleDayTime[]

  @Prop() slideLoaded!:boolean

  get hourList() {
    const startTime = this.dayStartTime
    const hours:any[] = []
    for (let h = startTime; h < startTime + 25; h += 1) {
      hours.push({ text: prettyHour(h), value: h })
    }
    return hours
  }

  activeList = [true, true, true, true, true, true, true]

  setAllStart:any = null

  setAllEnd:any = null

  allFullTime() {
    this.times = this.times.map(x => ({ start: this.dayStartTime, end: this.dayStartTime + 24 }))
  }

  captureLoad = false

  @Watch('slideLoaded', { immediate: true })
  setTimesActive() {
    if (!this.slideLoaded || this.captureLoad) return false
    console.log('all times going')
    // This will make necessary dates inactive
    this.times.forEach((time, index) => {
      if (time.start === time.end) {
        this.times[index].start = this.dayStartTime
        this.times[index].end = this.dayStartTime
        this.activeList[index] = false
        this.captureLoad = true
      }
    })
    return true
  }

  async updateAllStart() {
    if (this.setAllStart === null) return false
    this.times.forEach((day, index:number) => {
      if (this.activeList[index]) {
        // @eslint-disable-next-line
        if (this.times[index].end <= this.setAllStart) {
          this.times[index].end = this.setAllStart
        }
        this.times[index].start = this.setAllStart
      }
    })
    await this.$nextTick()
    this.setAllStart = null
    return true
  }


  async updateAllEnd() {
    if (this.setAllEnd === null) return false
    this.times.forEach((day, index:number) => {
      if (this.times[index].start >= this.setAllEnd) this.times[index].start = this.setAllEnd
      this.times[index].end = this.setAllEnd
    })
    await this.$nextTick()
    this.setAllEnd = null
    return true
  }

  @Watch('activeList', { deep: true })
  updateActiveList(newList:boolean[]) {
    newList.forEach((x:boolean, index) => {
      console.log('x: ', x, 'Index: ', index)
      if (!x) {
        this.times[index].start = this.dayStartTime
        this.times[index].end = this.dayStartTime
      }
    })
  }

  makeFullDay(index:number) {
    this.times[index].start = this.dayStartTime
    this.times[index].end = this.dayStartTime + 24
  }

  changeStart(index:any, value:any) {
    console.log('error:', index, '/n', value)
    if (this.times[index].end < value) {
      this.times[index].end = value
    }
  }

  @Watch('dayStartTime')
  changedStartTime(newTime:number) {
    this.times.forEach((day, index) => {
      if (day.start < newTime) {
        if (this.times[index].end < newTime) {
          this.times[index].end = newTime
        }
        this.times[index].start = newTime
      }
    })
  }
}
